<template>
  <a-drawer
    :maskClosable="false"
    width="70%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onClose"
    :destroyOnClose="true"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-descriptions :column="4" title="业主信息" class="full-width-descriptions">
      <a-descriptions-item label="业主姓名"> {{ form.ownerName }} </a-descriptions-item>
      <a-descriptions-item label="业主电话"> {{ form.ownerPhone }} </a-descriptions-item>
      <a-descriptions-item label="小区名称"> {{ form.minAreaName }} </a-descriptions-item>
      <a-descriptions-item label="详细地址"> {{ form.ownerAddress }} </a-descriptions-item>
      <a-descriptions-item label="预约时间">
        {{ form.reservationTime }}
      </a-descriptions-item>
    </a-descriptions>
    <a-descriptions :column="4" title="订单信息" class="full-width-descriptions">
      <a-descriptions-item label="服务单号"> {{ form.orderNo }} </a-descriptions-item>
      <a-descriptions-item label="订单类型">
        {{ form.orderType == 0 ? '普通服务单' : '预约服务单' }}
      </a-descriptions-item>
      <a-descriptions-item label="企业品牌"> {{ form.tenantFirmName }} </a-descriptions-item>
      <a-descriptions-item
label="经销商"
        >{{ form.tenantAgentId == form.tenantId ? form.tenantName : form.tenantAgentName }}
      </a-descriptions-item>
      <a-descriptions-item
        label="分销商"
        v-if="form.tenantAgentId !== form.tenantId && form.tenantFirmId !== form.tenantId"
      >
        {{ form.tenantName }}
      </a-descriptions-item>
      <a-descriptions-item label="验收员名称"> {{ form.pressureTestName }} </a-descriptions-item>
      <a-descriptions-item label="验收员电话"> {{ form.pressureTestUserPhone }} </a-descriptions-item>
      <a-descriptions-item label="水工姓名"> {{ form.waterName }} </a-descriptions-item>
      <a-descriptions-item label="水工电话"> {{ form.waterPhone }} </a-descriptions-item>
      <a-descriptions-item label="设备MAC"> {{ form.devCode }} </a-descriptions-item>

      <a-descriptions-item label="备注"> {{ form.remark }} </a-descriptions-item>
      <a-descriptions-item label="驳回原因"> {{ form.acceptRemark }} </a-descriptions-item>
      <a-descriptions-item label="连接点检查"> {{ reportInfoResult.connectionCheck }} </a-descriptions-item>
      <a-descriptions-item label="服务类型"> {{ reportInfoResult.serviceTypeName }} </a-descriptions-item>
      <a-descriptions-item label="预设压力"> {{ reportInfoResult.presetPressure }} </a-descriptions-item>
      <a-descriptions-item label="业主在场"> {{ reportInfoResult.ownersPresent ? '在' : '否' }} </a-descriptions-item>
      <a-descriptions-item label="全套产品">
        {{ reportInfoResult.completeProducts ? '是' : '否' }}
      </a-descriptions-item>
      <a-descriptions-item label="预设时间"> {{ reportInfoResult.presetTime }} </a-descriptions-item>
      <a-descriptions-item label="房屋面积"> {{ reportInfoResult.housingArea }} </a-descriptions-item>
      <a-descriptions-item label="房屋类型"> {{ reportInfoResult.houseType }} </a-descriptions-item>
      <a-descriptions-item label="起始压力"> {{ reportInfoResult.initialPressure }} </a-descriptions-item>
      <a-descriptions-item label="购买渠道"> {{ reportInfoResult.purchaseChannels }} </a-descriptions-item>
      <a-descriptions-item label="装修情况"> {{ reportInfoResult.decorationSituation }} </a-descriptions-item>
      <a-descriptions-item label="结束压力"> {{ reportInfoResult.endPressure }} </a-descriptions-item>
      <a-descriptions-item label="施工主体"> {{ reportInfoResult.constructionSubject }} </a-descriptions-item>
      <a-descriptions-item label="施工属性"> {{ reportInfoResult.constructionAttributes }} </a-descriptions-item>
      <a-descriptions-item label="过程降压"> {{ reportInfoResult.processPressureDrop }} </a-descriptions-item>
      <a-descriptions-item label="品牌"> {{ reportInfoResult.valveBrand }} </a-descriptions-item>
      <a-descriptions-item label="装修公司"> {{ reportInfoResult.decorationCompany }} </a-descriptions-item>
      <a-descriptions-item label="开始时间"> {{ reportInfoResult.startTime }} </a-descriptions-item>
      <a-descriptions-item label="质保承诺" :span="3"> {{ reportInfoResult.warrantyCommitment }} </a-descriptions-item>
      <a-descriptions-item label="安装方式"> {{ installationMethods }} </a-descriptions-item>
      <a-descriptions-item label="结束时间"> {{ reportInfoResult.endTime }} </a-descriptions-item>
      <a-descriptions-item label="施工空间"> {{ spatialDataFour }} </a-descriptions-item>
      <a-descriptions-item label="业主评价">
        {{
          reportInfoResult.ownerEvaluate == 0
            ? '未评价'
            : reportInfoResult.ownerEvaluate == 1
            ? '非常满意'
            : reportInfoResult.ownerEvaluate == 2
            ? '满意'
            : '不满意'
        }}
      </a-descriptions-item>
      <a-descriptions-item label="判断结果"> {{ pressureResult }} </a-descriptions-item>
    </a-descriptions>
    <a-descriptions :column="4" title="审核信息" class="full-width-descriptions">
      <a-form-model ref="form" :model="form" :rules="rules">
        <template v-if="showId === 1">
          <a-form-model-item label="审核状态" prop="acceptStatus">
            <a-radio-group button-style="solid" v-model="form.acceptStatus">
              <a-radio-button :value="2"> 审核打回 </a-radio-button>
              <a-radio-button :value="3"> 通过 </a-radio-button>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item label="备注" prop="remarkVal" v-if="form.acceptStatus == 2">
            <a-input v-model="form.remarkVal" style="width: 500px" placeholder="请输入" type="textarea" allow-clear />
          </a-form-model-item>
        </template>
        <template v-else-if="showId === 10">
          <a-form-model-item label="VR文件" prop="vrFiles">
            <file-upload
              type="image"
              :defaultList="form.vrFiles"
              :file="form.stampImg"
              @input="getImg($event, 'vrFiles')"
              :count="12"
              :isUpload="false"
            ></file-upload>
          </a-form-model-item>
          <a-form-model-item label="VR地址" prop="vrUrl">
            <a-input v-model="form.vrUrl" placeholder="请输入" type="textarea" allow-clear />
          </a-form-model-item>
        </template>
        <template v-else-if="showId === 3">
          <div v-for="(item, index) in form.params" :key="index" class="model_t">
            <a-input v-model="item.dealersIntegral" placeholder="请输入经销商金豆"></a-input>
            <a-input
              v-model="item.inspectorPoints"
              placeholder="请输入验收员积分"
              oninput="value=value.replace(/[^\d]/g,'')"
            ></a-input>
            <a-input
              v-model="item.hydraulicIntegral"
              placeholder="请输入水工积分"
              oninput="value=value.replace(/[^\d]/g,'')"
            ></a-input>
            <a-input
              v-model="item.quantity"
              placeholder="请输入数量"
              oninput="value=value.replace(/[^\d]/g,'')"
            ></a-input>
          </div>
        </template>
        <template v-else-if="showId === 4">
          <a-form-model-item label="验收员" prop="pressureTestUserId">
            <a-select
              show-search
              v-model="form.pressureTestUserId"
              placeholder="请选择"
              option-filter-prop="children"
              :filter-option="filterOption"
              @change="handleChange"
              style="width: 500px"
            >
              <a-select-option
v-for="d in inspector"
:key="d.userId"
                >{{ d.userName }}({{ d.userPhone }})</a-select-option
              >
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="备注" prop="remarkVal">
            <a-input style="width: 500px" v-model="form.remarkVal" placeholder="请输入" type="textarea" allow-clear />
          </a-form-model-item>
        </template>
        <div class="bottom-control">
          <a-space>
            <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
            <a-button type="dashed" @click="cancel"> 取消 </a-button>
          </a-space>
        </div>
      </a-form-model>
    </a-descriptions>
  </a-drawer>
</template>
    <script>
import { getObj, orderExamine, orderVr, tenantUser, orderSend } from '@/api/pressure/dispatch'
import moment from 'moment'
import Examine from './examine'

export default {
  name: 'CreateForm',
  props: {
    statusOptions: {
      type: Array,
      required: false,
    },
  },
  components: { Examine },
  data() {
    const reg = /^1(3|4|5|6|7|8|9)\d{9}$/
    const validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入联系电话'))
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确的联系电话'))
      } else {
        callback()
      }
    }
    return {
      submitLoading: false,
      data: [],
      formTitle: '',
      inputValue: '',
      inputValues: '',
      pressureResult: '合格',

      spatialDataFour: '',
      // 表单参数
      form: {
        id: undefined,
        acceptStatus: 2,
        remarkVal: undefined,
      },
      isShow: false,
      installationMethods: '',
      open: false,
      inspector: [],
      reportInfoResult: {},
      showId: 1,
      info: {},
      rules: {
        pressureTestUserId: [{ required: true, message: '请选择验收员', trigger: 'blur' }],
        vrFiles: [{ required: true, message: '请上传VR文件', trigger: 'blur' }],
        vrUrl: [{ required: true, message: '请输入VR地址', trigger: 'blur' }],
        remarkVal: [{ required: true, message: '请输入备注', trigger: 'blur' }],
      },
    }
  },
  filters: {},
  created() {},
  computed: {},
  watch: {},
  methods: {
    // 时间选择
    onChange(e) {
      console.log(e, '121212888')
      this.form.reservationTime = moment(e).format('YYYY-MM-DD HH:mm')
    },
    onClose() {
      const that = this
      this.$confirm({
        title: '是否确认关闭清空数据',
        onOk() {
          console.log(that.open, 'openopen')
          that.open = false
        },
        onCancel() {},
      })
    },
      onChangeProvince(e) {
      console.log(e, 'dddd点点滴')
      if (e.code) {
        this.form.province = e.value
      } else {
        this.form.province = ''
        this.form.city = ''
        this.form.area = ''
      }
    },
    // 选择市
       onChangeCity(e) {
      if (e.code) {
        this.queryParam.city = e.value
      } else {
        this.queryParam.city = ''
        this.queryParam.area = ''
      }
    },
    // 选择区
      onChangeArea(e) {
      if (e.code) {
        this.queryParam.area = e.value
      } else {
        this.queryParam.area = ''
      }
    },
    // 查询验收和水工
    getUserList(type) {
      tenantUser({ type: type, pageNum: 1, pageSize: 999 }).then((res) => {
        this.inspector = res.data.records
        console.log(res.data, 'res.datares.datares.data')
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 取消按钮
    cancel() {
      this.onClose()
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        acceptStatus: 2,
        remarkVal: undefined,
      }
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.open = true
      this.formTitle = '添加预约订单'
    },
    // 验收员选择发生变化
    handleChange(e) {
      console.log(e, '的点点滴滴')
      this.inspector.forEach((v) => {
        if (v.userId === e) {
          this.form.pressureTestName = v.userName
          this.form.pressureTestUserPhone = v.userPhone
        }
      })
    },
    /** 修改按钮操作 */
    init(row, index) {
      console.log(row, 'rowrow')

      // this.reset()
      // this.form.id = row.id
      this.showId = index
      // getObj(row.id).then((response) => {
      //   console.log(response.data, 'response.data')
      //   this.form = response.data
      //   this.open = true
      //   this.form.params = response.data.reportInfoResult.productModelResults
      // })
      getObj(row.id).then((response) => {
        // console.log(response.data.reservationTime,'response.data.reservationTime')
        // response.data.reservationTimes = '2025-01-13 / 13:00 - 15:00'
        if (response.data.installationMethod) {
          const arr = response.data.installationMethod.split(',')
          response.data.installationMethods = ''
          arr.forEach((v, index) => {
            // this.
            if (index === arr.length - 1) {
              response.data.installationMethods += this.options[v]
            } else {
              response.data.installationMethods += this.options[v] + ','
            }
          })
        }
        this.form = response.data
        console.log(response.data.reportInfoResult.productModelResults, 'response.data.evaluateInfoResult')
        if (response.data.evaluateInfoResult) {
          this.evaluateInfoResult = response.data.evaluateInfoResult
        } else {
          this.evaluateInfoResult = null
        }

        // 试压图片
        if (response.data.reportInfoResult && response.data.reportInfoResult.fileManyFileResults) {
          // this.fileManyFileResults = response.data.reportInfoResult.fileManyFileRes
          // response.data.reportInfoResult.fileManyFileRes.forEach((v) => {
          //   this.optionsType.forEach((item) => {
          //     if (item.type === v.type) {
          //       item.files = v.files
          //     }
          //   })
          // })
          console.log('测试000555')
          this.optionsType = response.data.reportInfoResult.fileManyFileResults
          console.log()
        } else {
        }
        console.log('测试000======================')
        if (response.data.reportInfoResult.spatialData) {
          const arr = response.data.reportInfoResult.spatialData.split(',')
          // response.data.reportInfoResult.spatialDataOne = Number(arr[0])
          // response.data.reportInfoResult.spatialDataTwo = Number(arr[1])
          // response.data.reportInfoResult.spatialDataFree = Number(arr[2])
          // response.data.reportInfoResult.spatialDataFour = Number(arr[3])
          this.spatialDataFour =
            Number(arr[0]) + '室' + Number(arr[1]) + '厅' + Number(arr[2]) + '厨' + Number(arr[3]) + '卫'
        }
        const installationMethods = response.data.reportInfoResult.installationMethod
        if (installationMethods) {
          this.installationMethods =
            installationMethods.indexOf('0') !== -1
              ? '地面走管,'
              : '' + installationMethods.indexOf('1') !== -1
              ? '墙面走管,'
              : '' + installationMethods.indexOf('2') !== -1
              ? '屋顶走管,'
              : ''
        }
        if (response.data.reportInfoResult.startTime) {
          const array = response.data.reportInfoResult.pressureDataResults
          // if (array && array.length) {
          //   const leg = array.length - 1
          //   // response.data.reportInfoResult.endTime = array[leg].time
          //   // response.data.reportInfoResult.endTime = array[leg].time
          // } else {
          //   // console.log(response.data.reportInfoResult.startTime, 'startTimestartTimestartTime')
          //   // console.log(response.data.reportInfoResult.presetTime, 'presetTimepresetTimepresetTime')
          //   const presetTime = response.data.reportInfoResult.presetTime
          //   // response.data.reportInfoResult.endTime = moment(response.data.reportInfoResult.startTime)
          //   //   .add(presetTime, 'minutes')
          //   //   .format('YYYY-MM-DD HH:mm:ss')
          // }
        }
        this.reportInfoResult = response.data.reportInfoResult
        // this.productModelResults = response.data.productModelResults
        if (response.data.reportInfoResult) {
          const porModel = response.data.reportInfoResult.productModelResults
          this.form.pointsWater = 0
          this.form.pointsExaminer = 0
          this.form.golden02 = 0
          this.form.golden01 = 0
          porModel.forEach((v) => {
            v.flage = false
            this.form.golden01 += v.golden01
            this.form.golden02 += v.golden02
            this.form.pointsExaminer += v.pointsExaminer
            this.form.pointsWater += v.pointsWater

            // v.inspectorPoints = 0
            // v.dealersIntegral = 0
            // v.hydraulicIntegral = 0
            // console.log(v,'顶顶顶顶======');
          })
          this.productModelResults = porModel
        } else {
          this.productModelResults = []
        }
        const time = []
        const data = []
        if (this.reportInfoResult.pressureDataResults && this.reportInfoResult.pressureDataResults.length) {
          this.reportInfoResult.pressureDataResults.forEach((v) => {
            time.push(v.time)
            data.push(v.data)
          })
          this.chartData = {
            time: time,
            data: data,
          }
        }
        this.open = true
        this.formTitle = '审核'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      console.log(this.form, '对对对对对对')
      this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
          if (this.showId === 4) {
            orderSend(this.form)
              .then((response) => {
                this.$message.success('操作成功', 3)
                this.open = false
                this.$emit('ok')
                this.$emit('changeStatus')
              })
              .finally(() => {
                this.submitLoading = false
                this.showLoading = false
              })
          } else if (this.showId === 1) {
            orderExamine(this.form)
              .then((response) => {
                this.$message.success('审核成功', 3)
                this.open = false
                this.$emit('ok')
                this.$emit('changeStatus')
              })
              .finally(() => {
                this.submitLoading = false
                this.showLoading = false
              })
          } else {
            orderVr(this.form)
              .then((response) => {
                this.$message.success('操作成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
                this.showLoading = false
              })
          }
        } else {
          return false
        }
      })
    },
  },
}
</script>
    <style lang="less" scoped>
.model_t {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  input {
    width: 30%;
    margin-right: 10px;
  }
}
</style>